/* eslint-disable max-params */
/* global angular, _ */
module.exports = ['$scope', 'bibContentManager', '$location', '$q', 'curriculumManager', '$state', '$transitions', '$stateParams', 'settings', '$notification', 'messages', 'ngMeta', '$rootScope',
  function ($scope, bibContentManager, $location, $q, curriculumManager, $state, $transitions, $stateParams, settings, $notification, messages, ngMeta, $rootScope) {
    'use strict';
    ngMeta.setTitle('Bib: begrippen');
    $scope.$parent.hideSearchBar = false;

    $scope.location = $location.search();
    $scope.details = $state.params.key;
    $scope.searching = true;
    $scope.results = [];

    $transitions.onStart({}, function ($transition) {
      if ($transition.$to().name === 'bib.search.term.display') {
        $scope.details = $transition.$to().params.key;
      } else if($transition.$to().name === 'bib.search.term' && $transition.$from().name === 'bib.search.term.display') {
        $scope.details = $transition.$to().params.key;
        if ($scope.results.length === 0) {
          $scope.$parent.search();
        }
      }
    });

    // If user already selected a field, theme, goal age range or query, keep it selected...
    // ...except if it comes from the concordanties page.
    $scope.$parent.selected = $scope.$parent.selected && $rootScope.previousState !== 'bib.search.concordanties' ? $scope.$parent.selected : {};
    $scope.$parent.options = {};
    $scope.$parent.loaded = false;
    $scope.options = {};

    $scope.$parent.search = function () {
      var qparam;
      var contentRoot = $q.defer();
      var contentRootProm = contentRoot.promise;
      $scope.searching = true;
      $state.go('bib.search.term');

      if ($scope.$parent.selected.goal && $scope.$parent.selected.goal.type === 'goal') {
        contentRoot.resolve('/content/' + $scope.$parent.selected.goal.key);
      } else if ($scope.$parent.selected.theme && $scope.$parent.selected.theme.type === 'theme') {
        contentRoot.resolve('/content/' + $scope.$parent.selected.theme.key);
      } else if ($scope.$parent.selected.field && $scope.$parent.selected.field.type === 'field') {
        contentRoot.resolve('/content/' + $scope.$parent.selected.field.key);
      } else if ($scope.$parent.selected.field.key === '0') {
        contentRoot.resolve(null);
      }

      if ($scope.$parent.selected.q) {
        qparam = $scope.$parent.selected.q;
      }

      contentRootProm.then(function (root) {
        bibContentManager.getContentReferenced(root, ['ZILL_TERM'], qparam).then(function (results) {
          console.log(results);
          results.forEach(function (result) {
            result.fields = [];
            if (!result.referencedGenericGoals) {
              console.warn('No referencedGenericGoals for', result);
              return;
            }
            result.referencedGenericGoals.forEach(function (goal) {
              var fieldHref = goal.type === 'CURRICULUM_ZILL_DEVELOPMENT_FIELD'
                ? goal.href
                : goal.ancestors.find(ancestor => ancestor.type === 'CURRICULUM_ZILL_DEVELOPMENT_FIELD').href;
              curriculumManager.getFieldByHref(fieldHref).then(function (field) {
                if (typeof field != 'undefined' && !result.fields.some(fieldAlreadyPushed => fieldAlreadyPushed.key === field.key)) {
                  if(field.key === $scope.$parent.selected.field.key) {
                    result.fields = _.concat(field, result.fields);
                  } else {
                    result.fields.push(field);
                  }
                }
              });
            });
          });
          $scope.results = results;
          $scope.results = _.orderBy($scope.results, function (o) { return o.title; }, 'asc');
          $scope.searching = false;
        }, function (err) {
          console.error(err);
          $notification.error(messages.search.error);
        });
      });
    };

    var options = {
      field: [
        {
          key: '0',
          type: 'static',
          icon: 'fa-archive',
          color: '#000000',
          title: 'volledige praktijk-bib'
        }
      ],
      goal: [
        {
          key: '0',
          type: 'static',
          icon: '',
          color: '',
          title: 'geen doel'
        }
      ],
      theme: [
        {
          key: '0',
          type: 'static',
          icon: '',
          color: '',
          title: 'geen thema'
        }
      ]
    };

    function loadOptions(fields) {
      fields.forEach(function (value) {
        options.field.push({
          type: 'field',
          key: value.key,
          title: value.title,
          color: value.color,
          iconUrl: value.iconUrl,
          themes: value.themes.map(function (theme) {
            return {
              type: 'theme',
              key: theme.key,
              title: theme.title,
              goals: theme.goals.map(function (goal) {
                return {
                  type: 'goal',
                  key: goal.key,
                  title: goal.title,
                  code: goal.code
                };
              })
            };
          })
        });
      });

      options.field.forEach(function (field) {
        if(field.themes) {
          field.themes = _.concat(options.theme, field.themes);
          field.themes.forEach(function (theme) {
            if (theme.goals && theme.type == 'theme') {
              theme.goals = _.concat(options.goal, theme.goals);
            }
          });
        }
      });


      $scope.$parent.options = options;

      // $scope.$parent.selected includes multiple values, and some of them are later consumed in the template.
      // Among them, there are values for the selectors and inputs of the search form.
      // The defaults are set in the following way:
      // search parameters > already selected values > first value in the list of options.
      if ($stateParams.field && _.findIndex($scope.$parent.options.field, function (o) { return o.key === $stateParams.field; }) > -1) {
        $scope.$parent.selected.field = _.find($scope.$parent.options.field, function (o) { return o.key === $stateParams.field; });
      } else {
        $scope.$parent.selected.field = $scope.$parent.selected.field ? $scope.$parent.selected.field : $scope.$parent.options.field[0]; //set first as selected
      }

      if ($scope.$parent.selected.field.themes) {
        if ($stateParams.theme && _.findIndex($scope.$parent.selected.field.themes, {key: $stateParams.theme}) > -1) {
          $scope.$parent.selected.theme = _.find($scope.$parent.selected.field.themes, {key: $stateParams.theme});
        } else {
          $scope.$parent.selected.theme = $scope.$parent.selected.theme ? $scope.$parent.selected.theme : $scope.$parent.selected.field.themes[0]; //set first as selected
        }
      }

      if ($scope.$parent.selected.theme && $scope.$parent.selected.theme.goals) {
        if ($stateParams.goal && _.findIndex($scope.$parent.selected.theme.goals, function (o) {
          return o.key == $stateParams.goal;
        })) {
          $scope.$parent.selected.goal = _.find($scope.$parent.selected.theme.goals, function (o) {
            return o.key == $stateParams.goal;
          });
        } else {
          $scope.$parent.selected.goal = $scope.$parent.selected.goal ? $scope.$parent.selected.goal : $scope.$parent.selected.theme.goals[0]; //set first as selected
        }
      }

      if ($stateParams.q) {
        $scope.$parent.selected.q = $stateParams.q;
      }
    }

    curriculumManager.getFields().then(function (fields) {
      loadOptions(fields);
      $scope.fields = fields;
      $scope.$parent.loaded = true;
      if(!$scope.details) {
        $scope.$parent.search();
      }
    });

  }
];



// WEBPACK FOOTER //
// ./web/js/screen/bib/search/term/bibSearchTermController.js